import React from 'react'
import styles from './ProdottoDisclaimer.module.sass'


interface Props {
  text: string
  className?: string
}

const ProdottoDisclaimer = (props: Props) => {

  const { 
    text = '',
    className = '',
  } = props

  return text ? (
    <div className={`${styles.root} ${className}`}>
      {text}
    </div>
  ) : <></>
}

export default ProdottoDisclaimer
